export enum MaskType {
  phone = "phone",
  ssn = "ssn",
  date = "date",
  currency = "currency",
}
